import {useEffect,useId,useRef,useState} from 'react';
import {renameEntryIssue,libraryRenameSelection,normalizedRenameName,type RenameLibraryEntry} from '../library-rename';
import './create-folder-dialog.css';

export interface RenameLibraryDialogProps {
  entry:RenameLibraryEntry|null;
  onRename:(entry:RenameLibraryEntry,name:string)=>Promise<void>;
  onClose:()=>void;
}

export function RenameLibraryDialog({entry,...props}:RenameLibraryDialogProps) {
  return entry?<RenameForm key={`${entry.kind}:${entry.id}`} entry={entry} {...props}/>:null;
}

function RenameForm({entry,onRename,onClose}:RenameLibraryDialogProps&{entry:RenameLibraryEntry}) {
  const [name,setName]=useState(entry.name),[error,setError]=useState(''),[busy,setBusy]=useState(false);
  const dialog=useRef<HTMLDialogElement>(null),input=useRef<HTMLInputElement>(null);
  const mounted=useRef(false),submitting=useRef(false),initial=useRef(entry);
  const id=useId(),label=entry.kind==='thread'?'对话':entry.kind==='folder'?'文件夹':'文件';
  useEffect(()=>{
    mounted.current=true;
    const element=dialog.current;
    element?.showModal();input.current?.focus();
    input.current?.setSelectionRange(...libraryRenameSelection(initial.current));
    return()=>{mounted.current=false;element?.close();};
  },[]);

  async function submit(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if(submitting.current)return;
    const value=normalizedRenameName(entry.kind,name),issue=renameEntryIssue(entry.kind,name);
    if(issue){setError(issue);input.current?.focus();return;}
    if(value===entry.name){onClose();return;}
    submitting.current=true;setBusy(true);setError('');
    try {
      await onRename(entry,value);
      if(mounted.current)onClose();
    }catch(value){
      if(mounted.current){setError(value instanceof Error?value.message:'重命名失败，请重试。');input.current?.focus();}
    }finally{
      submitting.current=false;if(mounted.current)setBusy(false);
    }
  }

  return <dialog ref={dialog} className="library-create-folder-dialog library-rename-dialog" aria-labelledby={`${id}-title`} aria-describedby={`${id}-original`} onCancel={event=>{event.preventDefault();if(!submitting.current)onClose();}}>
    <form onSubmit={event=>void submit(event)} noValidate aria-busy={busy}>
      <h3 id={`${id}-title`}>重命名{label}</h3>
      <p id={`${id}-original`}>原名称：<span>{entry.name}</span></p>
      <label htmlFor={`${id}-name`}>{label}名称</label>
      <input ref={input} id={`${id}-name`} name="entryName" type="text" autoComplete="off" required readOnly={busy} value={name} aria-invalid={!!error} aria-describedby={error?`${id}-error`:undefined}
        onChange={event=>{setName(event.target.value);setError('');}}
        onKeyDown={event=>{if(event.key==='Enter'&&(event.nativeEvent.isComposing||event.keyCode===229))event.preventDefault();}}/>
      {error&&<p id={`${id}-error`} className="library-create-folder-error" role="alert">{error}</p>}
      <div className="library-create-folder-actions">
        <button type="button" disabled={busy} onClick={onClose}>取消</button>
        <button type="submit" disabled={busy||!name.trim()||normalizedRenameName(entry.kind,name)===entry.name}>{busy?'正在保存…':'保存'}</button>
      </div>
    </form>
  </dialog>;
}
